import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { JWT, ROUTES } from "../config/constants";
import { clearAllSessionStorage } from "../utils/sessionStorage";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem(JWT.TOKEN_KEY);

  // Jika tidak ada token, redirect ke login
  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // Cek expired token
  try {
    const decoded = jwtDecode(token);
    if (!decoded.exp || decoded.exp < Date.now() / 1000) {
      localStorage.removeItem(JWT.TOKEN_KEY);
      localStorage.removeItem(JWT.PROJECT_ID_KEY);
      localStorage.removeItem(JWT.PROJECT_NAME_KEY);
      localStorage.removeItem(JWT.NAMA_KEY);
      clearAllSessionStorage();
      return <Navigate to={ROUTES.LOGIN} replace />;
    }
  } catch {
    // Token invalid → bersihkan
    localStorage.removeItem(JWT.TOKEN_KEY);
    clearAllSessionStorage();
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return children;
}
